"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var internal_dataloader_1 = __importDefault(require("./utils/internal_dataloader"));
var internal_dataloadernode_1 = __importDefault(require("./utils/internal_dataloadernode"));
var moment_1 = __importDefault(require("moment"));
var MlbDataServer = /** @class */ (function () {
    /**
     * Creates a new data server
     * @param {(url: string) => string} urlTransformer If you need to use a proxy, this will allow you to hit that URL instead, given the MLB.com url
     * @param fetch If serverside, must pass a fetch functio
     */
    function MlbDataServer(urlTransformer) {
        var _this = this;
        this.urlTransformer = urlTransformer;
        this.searchPlaylist = function (playlist, page) {
            if (page === void 0) { page = 1; }
            return _this.searchPlaylistIso(playlist, page, false);
        };
        this.searchPlaylistNode = function (playlist, page) {
            if (page === void 0) { page = 1; }
            return _this.searchPlaylistIso(playlist, page, true);
        };
        this.searchTag = function (tag, page) {
            if (page === void 0) { page = 1; }
            return _this.searchTagIso(tag, page, false);
        };
        this.searchTagNode = function (tag, page) {
            if (page === void 0) { page = 1; }
            return _this.searchTagIso(tag, page, true);
        };
        this.videoTagSearch = function (tag, page) {
            if (page === void 0) { page = 1; }
            return _this.videoTagSearchIso(tag, page, false);
        };
        this.videoTagSearchNode = function (tag, page) {
            if (page === void 0) { page = 1; }
            return _this.videoTagSearchIso(tag, page, true);
        };
        this.videoPlaylistSearchNode = function (tag, page) {
            if (page === void 0) { page = 1; }
            return _this.videoPlaylistSearchIso(tag, page, true);
        };
        this.videoPlaylistSearch = function (tag, page) {
            if (page === void 0) { page = 1; }
            return _this.videoPlaylistSearchIso(tag, page, false);
        };
        if (urlTransformer) {
            internal_dataloader_1.default.transformUrl = urlTransformer;
        }
    }
    MlbDataServer.prototype.getLiveGame = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var liveGameUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        liveGameUrl = "http://statsapi.mlb.com/api/v1.1/game/" + gameId + "/feed/live";
                        return [4 /*yield*/, internal_dataloader_1.default.load(liveGameUrl, "liveGame")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getLiveGameNode = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var liveGameUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        liveGameUrl = "http://statsapi.mlb.com/api/v1.1/game/" + gameId + "/feed/live";
                        return [4 /*yield*/, internal_dataloadernode_1.default.load(liveGameUrl, "liveGame")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getGameMedia = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mediaUrl = "https://statsapi.mlb.com/api/v1/game/" + gameId + "/content?language=en";
                        return [4 /*yield*/, internal_dataloader_1.default.load(mediaUrl, "media")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getGameMediaNode = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mediaUrl = "https://statsapi.mlb.com/api/v1/game/" + gameId + "/content?language=en";
                        return [4 /*yield*/, internal_dataloadernode_1.default.load(mediaUrl, "media")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getPlayers = function (playerIds, year) {
        if (year === void 0) { year = -1; }
        return __awaiter(this, void 0, void 0, function () {
            var fixedYear, baseUrl, playersQuery, suffix, fullUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fixedYear = year === -1 ? moment_1.default().year() : year;
                        baseUrl = "https://statsapi.mlb.com/api/v1/people?";
                        playersQuery = "personIds=" + playerIds.join("&personIds=");
                        suffix = "&hydrate=stats(group=hitting,type=season,season=" + fixedYear + ",gameType=R)";
                        fullUrl = "" + baseUrl + playersQuery + suffix;
                        return [4 /*yield*/, internal_dataloader_1.default.load(fullUrl, "playerData")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getScoreboard = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            var dateString, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dateString = date.format("YYYY-MM-DD");
                        url = "https://statsapi.mlb.com/api/v1/schedule?sportId=1,51&date=" + dateString + "&gameTypes=E,S,R,A,F,D,L,W&hydrate=team(leaders(showOnPreview(leaderCategories=[homeRuns,runsBattedIn,battingAverage],statGroup=[pitching,hitting]))),linescore(matchup,runners),flags,liveLookin,review,broadcasts(all),decisions,person,probablePitcher,stats,homeRuns,previousPlay,game(content(media(featured,epg),summary),tickets),seriesStatus(useOverride=true)&useLatestGames=false&scheduleTypes=events,games&language=en&leagueIds=103,104,420";
                        return [4 /*yield*/, internal_dataloader_1.default.load(url, "schedule" + dateString)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getScoreboardNode = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            var dateString, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dateString = date.format("YYYY-MM-DD");
                        url = "https://statsapi.mlb.com/api/v1/schedule?sportId=1,51&date=" + dateString + "&gameTypes=E,S,R,A,F,D,L,W&hydrate=team(leaders(showOnPreview(leaderCategories=[homeRuns,runsBattedIn,battingAverage],statGroup=[pitching,hitting]))),linescore(matchup,runners),flags,liveLookin,review,broadcasts(all),decisions,person,probablePitcher,stats,homeRuns,previousPlay,game(content(media(featured,epg),summary),tickets),seriesStatus(useOverride=true)&useLatestGames=false&scheduleTypes=events,games&language=en&leagueIds=103,104,420";
                        return [4 /*yield*/, internal_dataloadernode_1.default.load(url, "schedule" + dateString)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getStandings = function (asOfDate) {
        return __awaiter(this, void 0, void 0, function () {
            var date, year, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        date = asOfDate.format("YYYY-MM-DD");
                        year = asOfDate.format("YYYY");
                        url = "https://statsapi.mlb.com/api/v1/standings?leagueId=103,104&season=" + year + "&date=" + date + "&standingsTypes=regularSeason,springTraining,firstHalf,secondHalf&hydrate=division,conference,sport,league,team(nextSchedule(team,gameType=[R,F,D,L,W,C],inclusive=false),previousSchedule(team,gameType=[R,F,D,L,W,C],inclusive=true))";
                        return [4 /*yield*/, internal_dataloader_1.default.load(url, "standings")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getTeamSchedule = function (teamId, season) {
        if (season === void 0) { season = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var now, dateString, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        now = moment_1.default();
                        dateString = now.format("YYYY-MM-DD");
                        season = !season ? now.year() : season;
                        url = "https://statsapi.mlb.com/api/v1/teams/" + teamId + "?hydrate=previousSchedule(date=" + dateString + ",season=" + season + ",limit=162,team,linescore(matchup),decisions,person),nextSchedule(date=" + dateString + ",season=" + season + ",limit=162,team,linescore(matchup,runners),decisions,person)";
                        return [4 /*yield*/, internal_dataloader_1.default.load(url, "schedule" + teamId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.getTeamDetails = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "https://statsapi.mlb.com/api/v1/teams/" + teamId;
                        return [4 /*yield*/, internal_dataloader_1.default.load(url, "teamdetails" + teamId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.searchPlaylistIso = function (playlist, page, isNode) {
        if (page === void 0) { page = 1; }
        if (isNode === void 0) { isNode = false; }
        var url = "https://www.mlb.com/data-service/en/search?page=" + page + "&sel=" + playlist + "-video-list&selCulture=en-us";
        return new Promise(function (resolve, reject) {
            var promise = isNode
                ? internal_dataloadernode_1.default.load(url, "playlistSearch")
                : internal_dataloader_1.default.load(url, "playlistSearch");
            promise
                .then(function (data) {
                resolve(data);
            })
                .catch(function (error) { return reject(error); });
        });
    };
    MlbDataServer.prototype.searchTagIso = function (tag, page, isNode) {
        if (page === void 0) { page = 1; }
        if (isNode === void 0) { isNode = false; }
        var url = "https://www.mlb.com/data-service/en/search?tags.slug=" + tag + "&page=" + page;
        return new Promise(function (resolve, reject) {
            var promise = isNode
                ? internal_dataloadernode_1.default.load(url, "videoTagSearch")
                : internal_dataloader_1.default.load(url, "videoTagSearch");
            promise
                .then(function (data) {
                resolve(data);
            })
                .catch(function (error) { return reject(error); });
        });
    };
    MlbDataServer.prototype.videoTagSearchIso = function (tag, page, isNode) {
        if (page === void 0) { page = 1; }
        if (isNode === void 0) { isNode = false; }
        return this.searchTagIso(tag, page, isNode).then(function (json) {
            var docs = json.docs;
            return Promise.all(docs);
        });
    };
    MlbDataServer.prototype.videoPlaylistSearchIso = function (tag, page, isNode) {
        if (page === void 0) { page = 1; }
        if (isNode === void 0) { isNode = false; }
        return this.searchPlaylistIso(tag, page, isNode).then(function (json) {
            var docs = json.docs;
            return Promise.all(docs);
        });
    };
    MlbDataServer.prototype.videoLocalSearch = function (text, page, gameIds, perPage) {
        if (page === void 0) { page = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/api/search?text=" + text + "&page=" + page;
                        if (gameIds) {
                            url += "&gameIds=" + gameIds;
                        }
                        if (perPage) {
                            url += "&perPage=" + perPage;
                        }
                        return [4 /*yield*/, fetch(url).then(function (r) { return r.json(); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MlbDataServer.prototype.fullVideoSearch = function (variables, page, limit) {
        if (page === void 0) { page = 0; }
        if (limit === void 0) { limit = 36; }
        return __awaiter(this, void 0, void 0, function () {
            var query, makeVar, encoded, url;
            return __generator(this, function (_a) {
                query = "Search($query: String!, $page: Int, $limit: Int, $feedPreference: FeedPreference, $languagePreference: LanguagePreference, $contentPreference: ContentPreference) {\n  search(query: $query, limit: $limit, page: $page, feedPreference: $feedPreference, languagePreference: $languagePreference, contentPreference: $contentPreference) {\n    plays {\n      mediaPlayback {\n        id\n        slug\n        blurb\n        timestamp\n        description\n        title\n        canAddToReel\n        feeds {\n          type\n          duration\n          image {\n            altText\n            templateUrl\n            cuts {\n              width\n              src\n              __typename\n            }\n            __typename\n          }\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    total\n    __typename\n  }\n}";
                makeVar = function (items) { return items.map(function (i) { return JSON.stringify(i); }).join(",").replace(/"/g, "\\\""); };
                encoded = Object.keys(variables)
                    .map(function (name) { return name + " = [" + makeVar(variables[name]) + "]"; })
                    .join(" AND ");
                url = "https://fastball-gateway.mlb.com/graphql?query=query%20" + encodeURIComponent(query) + "&operationName=Search&variables={\"query\":\"" + encoded + " Order By Timestamp\",\"limit\":" + limit + ",\"page\":" + page + ",\"languagePreference\":\"EN\",\"contentPreference\":\"MIXED\"}";
                return [2 /*return*/];
            });
        });
    };
    return MlbDataServer;
}());
exports.MlbDataServer = MlbDataServer;
